import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { profileMessages as m } from '../profileMessages';
/* eslint-disable css-modules/no-unused-class -- the look of the Music24 button; this link uses its base */
import buttonStyles from '../../../components/primitives/SMLButton.module.scss';
/* eslint-enable css-modules/no-unused-class */
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Profile; each part uses its own slice of it */
import styles from '../Profile.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * "Download" of a profile file (design a1): a same-origin link with `download`, so the browser saves
 * it under the name of the server ("LaziiBee - Spotify header.jpg").
 */
const ProfileDownloadLinkComponent: React.FC<{ href: string; testId?: string }> = ({ href, testId }) => {
  const intl = useIntl();
  return (
    <a className={clsx(buttonStyles.btn, styles.sm)} href={href} download data-testid={testId}>
      {intl.formatMessage(m.download)}
    </a>
  );
};

export const ProfileDownloadLink = TypedMemo(ProfileDownloadLinkComponent);
